<div
    class="visis visible fixed top-0 left-0 z-20 w-full bg-white/50 p-2 pt-4 pb-1 shadow-md backdrop-blur-xs xl:hidden"
>
    <div class="rounded-lg border border-gray-300 bg-white p-0">
        <p-button
            icon="pi pi-bars"
            [text]="true"
            severity="secondary"
            [rounded]="true"
            (click)="toggleSideMenu()"
            size="large"
        />
    </div>
</div>

@if (isSideMenuVisible()) {
    <div
        class="fixed z-40 h-full w-full bg-black/50 transition-opacity duration-300 xl:hidden"
        (click)="toggleSideMenu()"
        aria-hidden="true"
    ></div>
}

<nav
    class="invisible fixed top-0 left-0 z-40 h-full overflow-visible bg-gray-50 py-7 shadow-md transition-all duration-300 ease-in-out lg:translate-x-0 lg:py-2 xl:visible"
    [class.w-[260px]]="!isCollapsed()"
    [class.w-[64px]]="isCollapsed()"
    [class.px-2]="!isCollapsed()"
    [class.px-1]="isCollapsed()"
    [class.shadow-md]="isCollapsed()"
    [class.border-r]="isCollapsed()"
    [class.border-r-gray-200]="isCollapsed()"
    [class.translate-x-[-100%]]="!isSideMenuVisible()"
    [class.translate-x-0]="isSideMenuVisible()"
    [class.visible]="isSideMenuVisible()"
>
    @if (isSideMenuVisible()) {
        <p-button
            icon="pi pi-times"
            class="absolute top-2 right-2 z-50 xl:hidden"
            [text]="true"
            severity="secondary"
            [rounded]="true"
            (click)="toggleSideMenu()"
            size="large"
        />
    }

    <div class="mb-0 flex items-center" [class.justify-between]="!isCollapsed()" [class.justify-center]="isCollapsed()">
        @if (!isCollapsed()) {
            <img src="/favicon.png" alt="Ballance" class="h-auto w-[30px] cursor-pointer" (click)="goTo('/')" />

            <div
                class="mt-2 hidden xl:flex"
                [class.justify-center]="isCollapsed()"
                [class.justify-end]="!isCollapsed()"
            >
                <p-button
                    [icon]="isCollapsed() ? 'pi pi-chevron-right' : 'pi pi-chevron-left'"
                    severity="secondary"
                    [rounded]="true"
                    (click)="toggleCollapse()"
                    [pTooltip]="isCollapsed() ? 'Expand' : 'Collapse'"
                    tooltipPosition="right"
                    [text]="true"
                    size="small"
                    [class.right-4]="isCollapsed()"
                />
            </div>
        } @else {
            <div class="flex flex-col items-center gap-2 pt-6">
                <img
                    src="/favicon.png"
                    alt="Ballance"
                    class="h-auto w-[24px] cursor-pointer lg:mt-[24px]"
                    (click)="goTo('/')"
                />
                <p-button
                    icon="pi pi-chevron-right"
                    severity="secondary"
                    [rounded]="true"
                    (click)="toggleCollapse()"
                    pTooltip="Expand"
                    tooltipPosition="right"
                    [text]="true"
                    size="small"
                    class="hidden xl:flex"
                />
            </div>
        }
    </div>

    @if (!isCollapsed()) {
        <div class="flex justify-center py-2">
            <span
                class="rounded-full px-3 py-0.5 text-[10px] font-bold tracking-wider text-white uppercase"
                [class.bg-blue-600]="env === 'dev'"
                [class.bg-orange-500]="env === 'qa'"
                [class.bg-red-600]="env === 'prod'"
            >
                {{ env }}
            </span>
        </div>
    } @else {
        <div class="flex justify-center py-2">
            <span
                class="mt-2 inline-block h-[12px] w-[12px] rounded-full"
                [class.bg-blue-600]="env === 'dev'"
                [class.bg-orange-500]="env === 'qa'"
                [class.bg-red-600]="env === 'prod'"
            ></span>
        </div>
    }

    <div class="border-b border-gray-200 py-2">
        @for (item of menuItems(); track $index) {
            <div class="flex items-center" [class.justify-center]="isCollapsed()" [class.gap-2]="!isCollapsed()">
                <p-button
                    [icon]="item.icon"
                    [label]="isCollapsed() ? '' : item.label"
                    [text]="true"
                    severity="secondary"
                    (click)="goTo(item.routerLink)"
                    [pTooltip]="isCollapsed() ? item.label : ''"
                    tooltipPosition="right"
                    [class]="item.styleClass"
                />
            </div>
        }
    </div>

    <div
        class="absolute right-0 bottom-0 left-0 flex w-full flex-col gap-2 py-3"
        [class.px-4]="!isCollapsed()"
        [class.px-1]="isCollapsed()"
    >
        @if (!isCollapsed()) {
            <div class="flex items-center gap-3 rounded-full border border-gray-300 bg-white p-2">
                <div class="flex h-8 w-8 items-center justify-center rounded-full bg-blue-500 text-white">
                    <span class="text-sm font-semibold">{{ userInfo()?.initials }}</span>
                </div>

                <div class="flex flex-1 flex-col leading-tight">
                    <span class="w-[80px] truncate text-sm text-blue-800">{{ name() }}</span>
                </div>

                @if (!hideLogout()) {
                    <p-button
                        icon="pi pi-sign-out"
                        [text]="true"
                        severity="secondary"
                        [rounded]="true"
                        (click)="logout.emit()"
                        pTooltip="Logout"
                        tooltipPosition="top"
                    />
                }
            </div>
        } @else {
            <div class="flex flex-col items-center gap-2">
                <div
                    class="flex h-10 w-10 items-center justify-center rounded-full bg-blue-500 text-white"
                    pTooltip="{{ name() }}"
                    tooltipPosition="right"
                >
                    <span class="text-sm font-semibold">{{ userInfo()?.initials }}</span>
                </div>

                @if (!hideLogout()) {
                    <p-button
                        icon="pi pi-sign-out"
                        [text]="true"
                        severity="secondary"
                        [rounded]="true"
                        (click)="logout.emit()"
                        pTooltip="Logout"
                        tooltipPosition="right"
                    />
                }
            </div>
        }
    </div>
</nav>
